import { Ref, HTMLAttributes, Component, createElement } from 'react'
import ReactDOM from 'react-dom'

import { attachProps, createForwardRef, dashToPascalCase, isCoveredByReact } from './utils'
import { defineCustomElements, applyPolyfills } from '@ncr-design-system/keyboard/loader'

interface RegisterReactInternalProps<ElementType> extends HTMLAttributes<ElementType> {
  forwardedRef?: Ref<ElementType>
  href?: string
  routerLink?: string
  ref?: Ref<any>
}

declare global {
  interface Window {
    keyboard_components: any
  }
}

export const createReactComponent = <PropType, ElementType>(tagName: string) => {
  const displayName = dashToPascalCase(tagName)
  const ReactComponent = class extends Component<RegisterReactInternalProps<PropType>> {
    componentDidMount() {
      let _a
      // @ts-ignore
      let kb = (window.keyboard_components =
        ((_a = window.keyboard_components), _a !== null && _a !== void 0 ? _a : { loaded: false }))
      if (kb?.loaded === false) {
        kb.loaded = true
        applyPolyfills().then(() => {
          defineCustomElements()
        })
      }
      this.componentDidUpdate(this.props)
    }

    componentDidUpdate(prevProps: RegisterReactInternalProps<PropType>) {
      const node = ReactDOM.findDOMNode(this) as HTMLElement
      attachProps(node, this.props, prevProps)
    }

    render() {
      const { children, forwardedRef, style, className, ref, ...cProps } = this.props

      const propsToPass = Object.keys(cProps).reduce((acc, name) => {
        if (name.indexOf('on') === 0 && name[2] === name[2].toUpperCase()) {
          const eventName = name.substring(2).toLowerCase()
          if (isCoveredByReact(eventName)) {
            ;(acc as any)[name] = (cProps as any)[name]
          }
        }
        return acc
      }, {})

      const newProps: RegisterReactInternalProps<PropType> = {
        ...propsToPass,
        ref: forwardedRef,
        style
      }

      return createElement(tagName, newProps, children)
    }

    static get displayName() {
      return displayName
    }
  }
  return createForwardRef<PropType, ElementType>(ReactComponent, displayName)
}
